<div *ngIf="!!fieldData">
    <label class="control-label">{{fieldData.metadata.label}}</label>
    <br/>
    <div class="control-group">
        <div class="html-label" [innerHTML]="htmlTransform(fieldData.fieldValue)">
        </div>
    </div>
</div>
